import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { PackingSaveRequest } from "../../../models/picked-and-packed/packing-save-request.model";
import { PickedAndPackedResponse } from "../../../models/picked-and-packed/picked-and-packed-response.model";
import { SearchPrintResponse } from "../../../models/picked-and-packed/search-print-response.model";
import { SearchPrintRequest } from "../../../models/picked-and-packed/search-print-request.model";
import { PackedCreateBoxResponse } from "../../../models/picked-and-packed/packed-create-box-response.model";
import { Observable } from "rxjs";
import { BoxCustomerResponseModel } from "../../../models/picked-and-packed/box-customer-response.model";
import { BinToBulkRequest } from "../../../models/picked-and-packed/bin-to-bulk-request";

@Injectable({
	providedIn: 'root'
})
export class PackingService {

	private httpOptions = { headers: new HttpHeaders({ 'Content-type': 'application/json' }) };
	private subRoute = "pickedAndPacked";

	constructor(private http: HttpClient) {
		this.http = http;
	}

	getPacking(labelCode: string, subdivision: number) {
		const URL = environment.backend_Jab_url + this.subRoute + `/${labelCode}/subdivision/${subdivision}`
		return this.http.get<Array<PickedAndPackedResponse>>(URL);
	}

	searchToPrint(resquest: SearchPrintRequest) {
		const URL = environment.backend_Jab_url + "searchPrint/searchToPrint";
		return this.http.post<SearchPrintResponse>(URL, resquest);
	}

	newBox(boxCode: number, subdivision: number, printerHost: string, printerPort: number) {
		const URL = environment.backend_Jab_url + this.subRoute +
			`/create/${boxCode}/subdivision/${subdivision}/printerHost/${printerHost}/printerPort/${printerPort}`;
		return this.http.get<PackedCreateBoxResponse>(URL);
	}

	savePacking(packingSaveRequest: PackingSaveRequest) {
		const URL = environment.backend_Jab_url + this.subRoute;
		return this.http.put(URL, packingSaveRequest);
	}

	boxByCustomer(subdivision: number, bkCaseR: number, customerUid: number, outBatchUid: number): Observable<BoxCustomerResponseModel> {
		const URL = environment.backend_Jab_url + this.subRoute +
			`/${subdivision}/bkcaser/${bkCaseR}/customeruid/${customerUid}/outbatchuid/${outBatchUid}`
		return this.http.get<BoxCustomerResponseModel>(URL);
	}

	binToBulk(binToBulkRequest: BinToBulkRequest) {

		const URL = environment.backend_Jab_url + this.subRoute + "/binToBulk";
		return this.http.post<PickedAndPackedResponse>(URL, binToBulkRequest);
	}
}
